import { render, staticRenderFns } from "./LoadingPR.vue?vue&type=template&id=7bdca4ca&scoped=true&"
import script from "./LoadingPR.vue?vue&type=script&lang=js&"
export * from "./LoadingPR.vue?vue&type=script&lang=js&"
import style0 from "./LoadingPR.vue?vue&type=style&index=0&id=7bdca4ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdca4ca",
  null
  
)

export default component.exports